import { typography } from '@dentalux/ui-library-core'
import { Theme } from '@mui/material/styles'
import { createUseStyles } from 'react-jss'
import { forPhoneOnly } from 'src/config/mediaQueries'

export default createUseStyles((theme: Theme) => ({
  inputContainer: {
    display: 'flex',
    justifyContent: 'center',

    '& .otpInput': {
      width: 56,
      height: 56,
      borderRadius: 8,
      margin: 0,
      boxSizing: 'border-box',
      boxShadow: '0px 1px 3px rgba(0, 71, 52, 0.2)',
      justifyContent: 'center',
      ...typography['Lato H4'],
      color: theme.palette.grey[900],
      textAlign: 'center',

      '&:focus-visible': {
        outline: 'none',
        backgroundColor: theme.palette.primary[50],
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: theme.palette.primary[600],
      },

      '& fieldset': {
        border: 'none',
      },

      '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
        webkitAppearance: 'none',
        margin: 0,
      },
      '&:not(:last-child)': {
        marginRight: 12,
      },
      [forPhoneOnly]: {
        width: 48,
        height: 48,
        padding: 10,
      },
    },
  },
}))
